module.exports = __webpack_public_path__ + "img/Sculptor.fddb3204.png";